/* eslint-disable react/button-has-type */
/* global window */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';
import InfoPopupModern from 'components/InfoPopup/InfoPopupModern';
import { withTranslate } from 'react-redux-multilingual';
import { requestMorningstarRatings } from 'Actions/MorningstarActions';
import {
	requestResearchHistory,
	researchIdMap,
	getMorningstarReportsArgs
} from 'Actions/ResearchActions';
import MorningstarRating from 'components/MorningstarRating/MorningstarRating';
import './EtfMorningstarRating.scss';
import PdfLink from 'Views/Shared/LinkPdf/LinkPdf';

const EtfMorningstartRating = props => {
	const { format } = window;
	const {
		xids,
		translate
	} = props;
	const venue = get(xids, 'venue');
	const dispatch = useDispatch();
	const ratings = useSelector(state => get(state, 'morningstarData.morningstarRatings.items.0.values'));
	const document = useSelector(state => get(state, 'researchData.researchHistoryData.items.0'));
	const documentId = get(document, 'documentId');
	const documentDate = get(document, 'DocumentDate');
	const year3 = get(ratings, '0');
	const year5 = get(ratings, '1');
	const year10 = get(ratings, '2');
	const overallRating = get(ratings, '3');

	useEffect(() => {
		if (!venue) {
			return;
		}
		dispatch(requestMorningstarRatings([venue]));
		dispatch(requestResearchHistory(researchIdMap.cibcResearchHistory, getMorningstarReportsArgs(venue)));
	}, [xids]);

	return (
		<div className="etf-morningstar-rating">
			<div className="data-label">
				{translate('morningstarRating')}
				<InfoPopupModern size="small" leftShift={107}>
					{translate('morningstarTooltip')}
				</InfoPopupModern>
			</div>
			<div className="range-button">
				{ ratings && <MorningstarRating stars={overallRating} starSize="16px" /> }
				<div className="data-subtitle">
					{translate('overall')}
					<span className="sr-only">
						{documentDate ? format.monthDayYear(documentDate) : format.errorValue()}
					</span>
					{ ratings && (
						<InfoPopupModern iconName="downTriangle" helpText={translate('more')} leftShift={45} iconWidth={8}>
							<>
								<div className="font-weight-bold" style={{ minWidth: '95px' }}>{translate('3year')}</div>
								{year3
									? <MorningstarRating stars={year3} starSize="16px" style={{ marginBottom: '10px' }} />
									: format.errorValue()}
								<div className="font-weight-bold">{translate('5year')}</div>
								{year5
									? <MorningstarRating stars={year5} starSize="16px" style={{ marginBottom: '10px' }} />
									: format.errorValue()}
								<div className="font-weight-bold">{translate('10year')}</div>
								{year10
									? <MorningstarRating stars={year10} starSize="16px" />
									: format.errorValue()}
							</>
						</InfoPopupModern>
					) }
				</div>
				<div aria-hidden className="date">
					(
					{documentDate ? format.monthDayYear(documentDate) : format.errorValue()}
					)
				</div>
			</div>
			{ documentId && (
				<div className="etf-open-pdf">
					<PdfLink
						className="pdf-link"
						researchId={researchIdMap.wgrResearchHistory}
						headline={translate('openPdf')}
						documentId={documentId}
						docDate={documentDate}
						inlineFileSize
						sourceOnSecondLine={false}
						hideFileSize
						anchorClassName="text"
						wcUSsuage />
				</div>
			) }
		</div>

	);
};

export default withTranslate(EtfMorningstartRating);
